module.exports = require('fast-extend');
